import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox";
import SectionGridSubcategoriesBox from "components/SectionGridAuthorBox/SectionGridSubcategoriesBox";
import { getSubCategories } from "data/api";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

type Props = {};

const SubCategoriesPage = (props: Props) => {
  const { id } = useParams();
  const [items, setItems] = useState();

  useEffect(() => {
    getSubCategories(id!).then((resp) => setItems(resp.data));
  }, [id]);
  return (
    <div className="relative py-16 flex flex-row flex-wrap justify-center">
      <BackgroundSection />
      <SectionGridSubcategoriesBox boxCard="box2" subcategoriesList={items} />
    </div>
  );
};

export default SubCategoriesPage;
